import { render, staticRenderFns } from "./TournamentsFilters.vue?vue&type=template&id=7227e156&scoped=true"
import script from "./TournamentsFilters.vue?vue&type=script&lang=js"
export * from "./TournamentsFilters.vue?vue&type=script&lang=js"
import style0 from "./TournamentsFilters.vue?vue&type=style&index=0&id=7227e156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227e156",
  null
  
)

export default component.exports